<template>
    <div class="modal-backdrop">
        <div class="modal">
            <header class="modal-header">
                <slot name="header">
                    <h2>Zapis do tabeli</h2>

                    <button type="button"
                            class="btn-close"
                            @click="close"> x
                    </button>
                </slot>
            </header>
            <div class="modal-body">
                <slot name="body">
                    <div class="cad-msg">Dana konfiguracja nie widnieje w tabeli CAD. Podaj numer wentylatora
                        pod którym wybrana konfiguracja będzie widniała w tabeli CAD:
                    </div>
                    <label>
                        <masked-input v-model="value"
                                      name="cad"
                                      maxLength="7"
                                      placeholder="_ _ _ _ _ _ _"
                                      :mask="{pattern: '1 1 1 1 1 1 1',
                                             formatCharacters: {
                                               '*': {
                                                validate: char => /[A-Za-z0-9]/.test(char),
                                                transform: char => char.toUpperCase(),
                                                },},
                                             }"
                        />
                    </label>

                </slot>
            </div>
            <footer class="modal-footer">
                <slot name="footer">
                    <div class="navi-btns">
                        <span @click="close" class="back-btn circle-btn">
                        </span>
                        <button @click.prevent="tryApprove" class="summary-btn"> {{translate("Zatwierdz")}}</button>
                    </div>
                </slot>
            </footer>
        </div>
    </div>
</template>

<script>
    import SeparatedFields from "./SeparatedFields";
    import MaskedInput from 'vue-masked-input';

    export default {
        name: "modal",
        components: {
            SeparatedFields, MaskedInput
        },
        data() {
            return {
                value: '',
                isCorrect: false,
            }
        },
        methods: {

            tryApprove() {
                this.$store.state.productCard.custom['cad_number'] = this.value;
                this.$emit('approve');
            },

            translate(code, displayErrors = true) {
                let arg = {
                    type: 'translate',
                    code: code,
                    displayErrors: displayErrors,
                    out: ""
                }

                this.$store.commit(arg);

                return arg.out;
            },

            close() {
                this.$emit('close');
            },
        },
    }
</script>